<template>
  <div class="main">
    <div class="main-top">
      <div class="main-map">
        <aMap></aMap>
      </div>
      <div class="deal-center-info">
        <deal-center-info></deal-center-info>
      </div>
    </div>
    <div class="main-center">
      <main-center :activeName="activeName"></main-center>
    </div>
    <!-- <div class="main-bottom">
          <main-bottom></main-bottom>
      </div> -->
  </div>
</template>

<script>
import DealCenterInfo from "./seciton/deal-center-info.vue";
import aMap from "./components/map.vue";
import MainCenter from "./seciton/main-center.vue";
import MainBottom from "./seciton/main-bottom.vue";
export default {
  components: {
    aMap,
    DealCenterInfo,
    MainCenter,
    MainBottom,
  },
  data() {
    return {};
  },
  computed: {
    activeName() {
      return this.$route.query.activeName || "calculter";
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@import "@css/var.scss";
.main {
  width: 1200px;
  // margin-top: 21px;
  // height: 1600px;
  // background-color: aqua;

  .main-top {
    background-color: white;
    overflow: hidden;
    padding: 27px 0 45px;

    .main-map {
      width: 733px;
      height: 494px;
      float: left;
      overflow: hidden;
      // background-color: violet;
    }
    .deal-center-info {
      width: 387px;
      height: 494px;
      float: left;
      margin-left: 36px;
      // background-color: violet;
    }
  }
  .main-center {
    // max-height: 336px;
    width: 100%;
    background-color: white;
    margin-top: 15px;
    padding-left: 20px;
    padding-top: 10px;
  }
}
</style>
